$(function () {
    if (typeof authUser !== 'undefined' && authUser.rol_id == 3) {
        renderHomeCatalogos();
    }
});

window.renderSinResultados = function (id, mensaje) {
    return htmlSinResultados
        .replace('__ID__', id)
        .replace('__MENSAJE__', mensaje);
}

/**
 * Renders catalog blocks in home page
 */
window.renderHomeCatalogos = function () {
    catalogos.forEach(function (catalogo, index) {
        if (parseInt(catalogo.tipo) === 1) {
            renderBloqueCatalogo(catalogo, index);
        } else if (parseInt(catalogo.tipo) === 2) {
            renderBloqueTipoCatalogo(catalogo, index);
        } else if (parseInt(catalogo.tipo) === 3 && canViewCampana) {
            renderBloqueCampana(catalogo, index);
        }
    });
}
/**
 * Renders a catalog block in home page
 * @param {object} catalogo
 * @param {number} index
 */
window.renderBloqueCatalogo = function (catalogo, index) {

    $('#homeCatalogosContainer').append(`
        <section id="sectionCatalogo-${index}" class="catalog-section">
            <h2 class="section-title">
                <span>${catalogo.nombre ?? ''} </span>
                <a class="see-more" href="${urlArticulo}?buscador=*&campana_nombre_string=${catalogo.id}">
                    ${transVerTodos} <i class="ri-arrow-right-line"></i>
                </a>
                </h2>
            <div class="products-carousel">
                ${htmlLoader.replace('__ID__', `loadingResults-Catalogo-${index}`)}
                ${renderSinResultados(`sinResultados-Catalogo-${index}-`, transNoSeHanEncontradoResultados)}
            </div>
        </section>`);

    getArticulosByCatalogo(catalogo.id, function (response) {
        $(`#loadingResults-Catalogo-${index}`).remove();

        // Compruebo que no venga nada vacío
        if (response.html.length) {
            $(`#sectionCatalogo-${index} .products-carousel`).html(response.html).slick(defaultProductsCarouselOptions);
            inicializarPreciosYDtos();

            // Inicializo los posibles tooltips
            initializeTooltips();
        } else {
            $(`#sinResultados-Catalogo-${index}-Warning`).show()
        }
    });
}

/**
 *
 * Renders a catalog type block in home page
 * @param {object} catalogo
 * @param {number} index
 */
window.renderBloqueTipoCatalogo = function (catalogo, index) {
    $('#homeCatalogosContainer').append(`
        <section class="section section-bestsellers" id="sectionTipoCatalogo-${index}">
            <h2 class="section-title"> ${catalogo.nombre ?? ''} </h2>
            <div id="loadingResults-TipoCatalogo-${index}">
                ${htmlLoader.replace('__ID__', `loadingResults-TipoCatalogoInner-${index}`)}
            </div>
            <ul class="nav nav-pills mb-3" id="pillsTab-${index}" role="tablist"></ul>
            <div class="tab-content" id="pillsTabContent-${index}">
                <div class="tab-pane fade" role="tabpanel" id="pillsContentTemplate-${index}" style="display: none !important;">
                    <div class="products-carousel">
                        ${htmlLoader.replace('__ID__', `loadingResults-TipoCatalogo-${index}`)}
                        ${renderSinResultados(`sinResultados-TipoCatalogo-${index}-`, transNoSeHanEncontradoResultados)}
                    </div>
                </div>

            </div>
        </section>`);

    loadCatalogosByTipo(index, catalogo);
}

/**
 * Renders a catalog type block in home page
 * @param {object} catalogo
 * @param {number} index
 */
window.renderBloqueCampana = function (catalogo, index) {
    $('#homeCatalogosContainer').append(`
        <section class="section section-campaigns full-width" id="sectionCampanas-${index}">
            <div class="container-xxl">
                <h2 class="section-title">
                    ${transRecursoCampana}
                    <a class="see-more" href="${urlCampana}">
                        ${transVerTodos} <i class="ri-arrow-right-line"></i>
                    </a>
                <h2>
                <div class="campaign-carousel">
                    ${htmlLoader.replace('__ID__', `loadingResults-Campanas-${index}`)}
                    ${renderSinResultados(`sinResultados-Campanas-${index}-`, transNoSeHanEncontradoResultadosCampanas)}
                </div>
            </div>
        </section>`);

    loadCampanas(index);

}

/**
 * Loads featured news
 */
window.loadCatalogos = function () {
    catalogos.forEach(function (catalogo, index) {
        $(`#sectionCatalogo-${index + 1} .section-title span`).text(catalogo.nombre);
        $(`#sectionCatalogo-${index + 1} .section-title a`).attr('href', `${urlArticulo}?buscador=*&campana_nombre_string=${catalogo.id}`);
        getArticulosByCatalogo(catalogo.id, function (response) {
            $(`#loadingResults-Catalogo-${index + 1}`).remove();
            // Compruebo que no venga nada vacío
            if (response.html.length) {
                $(`#sectionCatalogo-${index + 1} .products-carousel`)
                    .html(response.html)
                    .slick(defaultProductsCarouselOptions);
                inicializarPreciosYDtos();

                // Inicializo los posibles tooltips
                initializeTooltips();
            } else {
                $(`#sinResultados-Catalogo-${index + 1}Warning`).show()
            }
        });
    });
}

/**
 * Loads catalogs by catalog type
 * @param {number} index
 * @param {object} catalogo
 */
window.loadCatalogosByTipo = function (index, catalogo) {
    $.ajax({
        url:      urlTipoCatalogo + `/${catalogo.id}/get`,
        type:     'GET',
        data:     {},
        dataType: 'json',
    })
     .done(function (response) {
         $(`#sectionTipoCatalogo-${index}`)
             .show()
             .find('h2.section-title').text(response.resource.nombre);

         response.catalogos.forEach(function (catalogo) {
             $(`#sectionTipoCatalogo-${index} #pillsTab-${index}`).append(`<li class="nav-item">
                    <button class="nav-link" id="pillsTab-${index}-${catalogo.id}" data-bs-toggle="pill" data-bs-target="#pillsContent-${index}-${catalogo.id}" type="button"  role="tab" aria-controls="pillsContent-${index}-${catalogo.id}" aria-selected="false" onclick="loadArticulosByCatalogo('${catalogo.id}','${index}')">${catalogo.nombre}</button>
                </li>`);

             let newPillsContent = $(`#sectionTipoCatalogo-${index} #pillsContentTemplate-${index}`)
                 .clone()
                 .appendTo(`#sectionTipoCatalogo-${index} #pillsTabContent-${index}`)
                 .attr('id', `pillsContent-${index}-${catalogo.id}`)
                 .attr('aria-labelledby', `pillsTab-${index}-${catalogo.id}`)
                 .removeAttr('style')
                 .find('.loadingResults')
                 .attr('id', `loadingResults-${index}-${catalogo.id}`)
                 .closest('.tab-pane')
                 .find('.sinResultados')
                 .attr('id', `sinResultadosWarning-${index}-${catalogo.id}`);
         });

         $(`#pillsContentTemplate-${index}`).remove();
         $(`#loadingResults-TipoCatalogo-${index}`).remove();
         loadArticulosByCatalogo(response.catalogos[0].id, index);
     })
     .fail(function (jqXHR, status, error) {
         if (jqXHR.status) {
             let errors = '';
             if (jqXHR.status === 422) {
                 errors = composeValidationError(jqXHR.responseJSON.errors);
             } else if (jqXHR.responseJSON.message) {
                 errors = jqXHR.responseJSON.message;
             }
             pNotifyError(errors);
         }
     });
}

/**
 * Loads articles by catalog
 *
 * @param {number} catalogo_id
 * @param {number} index
 */
window.loadArticulosByCatalogo = function (catalogo_id = null, index = null) {
    new bootstrap.Tab($(`#pillsTab-${index}-${catalogo_id}`)).show();
    if (!$(`#pillsContent-${index}-${catalogo_id}`).hasClass('loaded')) {
        getArticulosByCatalogo(catalogo_id, function (response) {
            $(`#loadingResults-${index}-${catalogo_id}`).remove();
            $(`#pillsContent-${index}-${catalogo_id}`).addClass('loaded');
            // Compruebo que no venga nada vacío
            if (response.html.length) {
                $(`#pillsContent-${index}-${catalogo_id} .products-carousel`)
                    .html(response.html)
                    .slick(defaultProductsCarouselOptions);
                inicializarPreciosYDtos();
            } else {
                $(`#sinResultadosWarning-${index}-${catalogo_id}`).show();
            }
        });
    }
}

/**
 * Get articles by catalog
 * @param catalogo_id
 * @param callback
 */
window.getArticulosByCatalogo = function (catalogo_id = null, callback = function () {
}) {
    $.ajax({
        url:      urlArticulo + '/get-html',
        type:     'POST',
        data:     {
            selectFields:   {
                eloquent: [
                    'articulos.id',
                ],
            },
            searchFields:   {
                eloquent: {
                    'campanas.clave': catalogo_id,
                }
            },
            join:           {
                articulo_campana: {
                    on: [
                        'articulos.id',
                        'articulo_campana.articulo_id',
                    ],
                },
                campanas:         {
                    on: [
                        'campanas.id',
                        'articulo_campana.campana_id',
                    ],
                },
            },
            orderBy:        [
                'articulo_campana.orden'
            ],
            orderDir:       [
                'asc'
            ],
            showFacets:     0,
            resultsPerPage: 25,
        },
        dataType: 'json',
    })
     .done(function (response) {
         callback(response);
     })
     .fail(function (jqXHR, status, error) {
         if (jqXHR.status) {
             let errors = '';
             if (jqXHR.status === 422) {
                 errors = composeValidationError(jqXHR.responseJSON.errors);
             } else if (jqXHR.responseJSON.message) {
                 errors = jqXHR.responseJSON.message;
             }
             pNotifyError(errors);
         }
     });
}

/**
 * Loads campaigns
 * @param {number} index
 */
window.loadCampanas = function (index) {
    $.ajax({
        url:      urlCampana + `/get`,
        type:     'POST',
        data:     {
            findIn: [
                'dele',
            ],
            // id_tipo_articulo: 'p',
        },
        dataType: 'json',
    })
     .done(function (response) {
         $(`#loadingResults-Campanas-${index}`).remove();
         // Compruebo que no venga nada vacío
         if (response.list.length) {
             $(`#sectionCampanas-${index} .campaign-carousel`).html('');
             response.list.forEach(function (campana) {
                 $(`#sectionCampanas-${index} .campaign-carousel`)
                     .append(`<div class="campaign-item">
                         <div class="campaign-img">
                             <a href="${urlCampana}/${campana.id}">
                                 ${campana.imagen.length ? `<img src="${campana.imagen}">` : ''}
                             </a>
                         </div>
                         <div class="campaign-info">
                            <div class="campaign-info-body">
                                <h3>${campana.nombre}</h3>
                                <p>${campana.descripcion}</p>
                            </div>
                             <div class="campaign-actions">
                                 ${campana.fecha_fin ? `<p>${transCampanaInfoFin}: ${date_format(campana.fecha_fin, 'YYYY-MM-DD')}</p>` : ''}
                                 <a class="see-more" href="${urlCampana}/${campana.id}">${transAccionVerArticulos}<i class="ri-arrow-right-line"></i></a>
                             </div>
                        </div>
                     </div>`);
             });
             $(`#sectionCampanas-${index} .campaign-carousel`).slick({
                 infinite:     true,
                 slidesToShow: 1,
                 prevArrow:    '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><i class="ri-arrow-left-s-line"></i></button>',
                 nextArrow:    '<button class="slick-next slick-arrow" aria-label="Next" type="button"><i class="ri-arrow-right-s-line"></i></button>',
             });
         } else {
             $(`#sinResultados-Campanas-${index}-Warning`).show()
         }
     })
     .fail(function (jqXHR, status, error) {
         if (jqXHR.status) {
             let errors = '';
             if (jqXHR.status === 422) {
                 errors = composeValidationError(jqXHR.responseJSON.errors);
             } else if (jqXHR.responseJSON.message) {
                 errors = jqXHR.responseJSON.message;
             }
             pNotifyError(errors);
         }
     });
}
